/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { catchError, EMPTY, finalize, tap } from 'rxjs';
import { IGroupModel, IGroupsListingFilterModel } from '../../../../models/groups.model';
import { GroupsService } from '../../../../services/api/groups/groups.service';
import { GroupContextService } from '../../../../services/helper/group-context/group-context.service';
import { LoaderService } from '../../../../services/loader/loader.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

@Component({
    selector: 'app-edit-pinned-group-popup',
    standalone: false,
    templateUrl: './edit-pinned-group-popup.component.html',
    styleUrl: './edit-pinned-group-popup.component.scss',
})
export class EditPinnedGroupPopupComponent extends BasePopupComponent {
    protected groupsData = signal<IGroupModel[]>([]);
    protected isInitialLoading = signal<boolean>(true); // For skeleton loader
    private page = 1;
    private size = 20;
    private allLoaded = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: any,
        protected override dialogRef: MatDialogRef<EditPinnedGroupPopupComponent>,
        private dialog: MatDialog,
        private groupContextService: GroupContextService,
        private groupsService: GroupsService,
        private loaderService: LoaderService,
    ) {
        super(data, dialogRef);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.loadMyGroups(true);
    }

    protected notifyUpdatedPinnedGroups(): void {
        this.groupContextService.notifyPinnedGroupsListUpdated();
    }

    protected onScroll(): void {
        this.loadMyGroups(false);
    }

    private loadMyGroups(reset = false, filter?: IGroupsListingFilterModel): void {
        if (this.allLoaded && !reset) {
            return;
        }

        if (reset) {
            this.page = 1;
            this.allLoaded = false;
            this.groupsData.set([]);
            this.isInitialLoading.set(true);
        }

        this.loaderService.show();
        this.groupsService
            .getGroupsListing({ ...filter, page: this.page, size: this.size })
            .pipe(
                tap((response) => {
                    this.groupsData.update((prev) => [...prev, ...response.result]);
                    if (response.result.length < this.size) {
                        this.allLoaded = true;
                    } else {
                        this.page++;
                    }
                }),
                catchError((error) => {
                    const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                    errorPopupConfig.data = {
                        title: `Error`,
                        message: error.error?.message,
                    };
                    this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                    console.error('Error getting groups listing:', error);
                    return EMPTY;
                }),
                finalize(() => {
                    this.isInitialLoading.set(false);
                    this.loaderService.hide();
                }),
            )
            .subscribe();
    }
}
